// removed by extract-text-webpack-plugin
module.exports = {"EditorDropzone":"EditorDropzone__ZIGN_J_GNcF0"};